module.exports = __webpack_public_path__ + "media/country_flags/mw-6f74aa37.png";